import LoadingBlock from "../LoadingBlock";
import FontAwesome from "../../../utilities/FontAwesome";
import styles from '../styles/SchoolFeedBlock.module.scss';
import ErrorBlock from "../ErrorBlock";
import SchoolFeedList from "../../../schoolfeed/SchoolFeedList";
import {useContext, useMemo} from "react";
import {StoreContext} from "../../../../stores/StoreLoader";
import useAsyncEffect from "../../../../hooks/useAsyncEffect";
import {observer} from "mobx-react";
import {SchoolFeedStore} from "../../../../stores/SchoolFeedStore";
import {SchoolFeedStoreContext} from "../../../schoolfeed/SchoolFeedWidget";
import {INewsBlockProps} from "./NewsBlock";

const SchoolFeedBlock = observer((props: INewsBlockProps) => {
    const schoolFeedStore = useMemo(() => new SchoolFeedStore(), []);
    const {organizationStore, userStore} = useContext(StoreContext);

    async function fetchMore(initial) {
        const q = {
            organization_id: organizationStore.currentOrganization.id,
        }
        if (!userStore.editor) {
            q["published"] = true;
        }
        if (initial) {
            await schoolFeedStore.fetchNews(q);
            await schoolFeedStore.fetchEvents(q);
        }
        else {
            await schoolFeedStore.fetchMore(q);
        }
    }

    useAsyncEffect(async () => {
        await fetchMore(true);
        if (!props.blockObj.asyncLoaded && !props.isBlockPreview) {
            props.blockObj.setAttributes({asyncLoaded: true});
        }
    }, []);

    if (schoolFeedStore.isFetching && schoolFeedStore.content.length === 0) { // also use data.length because when fetching subsequent pages we don't want to show loading block
        return <LoadingBlock/>
    } else if (schoolFeedStore.fetchStatus === "FAILURE") {
        return <ErrorBlock blockObj={{errorMessage: 'Oops! There was a problem fetching this feed.'}}/>
    }

    return <div className={styles.container}>
        <SchoolFeedStoreContext.Provider value={schoolFeedStore}>
            <SchoolFeedList showMedia={props.blockObj.sizeX > 1} allowCuration={false} content={schoolFeedStore.content} />
            {schoolFeedStore.isMore && <div>
                <button disabled={schoolFeedStore.isFetching} onClick={() => fetchMore(false)}>{schoolFeedStore.isFetching ?
                    <FontAwesome name={'fa-spinner'} prefix={'fas'} spin/> : "Fetch More Content"}</button>
            </div>}
        </SchoolFeedStoreContext.Provider>
    </div>;
})

export default SchoolFeedBlock;
